"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _textarea = require("baseui/textarea");

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Styled BaseWeb Textarea. See https://baseweb.design/components/textarea/
 */
const TextArea = props => {
  const {
    children,
    className = '',
    onChange,
    overrides,
    value,
    ...buiProps
  } = props;
  const TextAreaComponent = (0, _isNil.default)(value) ? _textarea.StatefulTextarea : _textarea.Textarea;

  function textAreaOnChange(event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(TextAreaComponent, _extends({
    onChange: textAreaOnChange,
    overrides: {
      // This does exist but it's not in the types for some reason
      // See https://github.com/uber/baseweb/blob/89095e1c177ed4793c5146f3df399201d6c14237/src/textarea/textarea.js#L54
      // @ts-ignore
      Root: {
        style: _style.getRootStyle
      },
      InputContainer: {
        style: _style.getInputContainerStyle
      },
      Input: {
        style: _style.getInputStyle
      },
      ...(overrides || {})
    },
    value: value
  }, buiProps)));
};

var _default = TextArea;
exports.default = _default;